<!-- 组件说明 -->
<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
    class="owner-list"
    :immediate-check="false"
  >
    <owner-info-item
      v-for="item in ownerList"
      :key="item.id"
      class="owner"
      :ownerItem="item.recommend"
      @initList="initList"
    />
  </van-list>
</template>

<script>
import { List as VanList } from "vant";
import OwnerInfoItem from "./OwnerInfoItem";
export default {
  props: {
    projectCode: {
      type: String,
    },
    orgCode: {
      type: String,
    },
  },
  components: { VanList, OwnerInfoItem },
  data() {
    return {
      ownerList: [],
      loading: false,
      finished: false,
      pageData: {
        size: 10,
        current: 1,
        // 客户状态
        statuses: 0,
        projectCode: this.projectCode,
        // 业主带访
        method: 2,
        // 入口-销售经理
        requestEntry: 1,
      },
    };
  },
  methods: {
    onLoad() {
      if (!this.finished) {
        this.pageData.current += 1;
        this.getList();
      }
    },
    // 获取列表
    getList() {
      this.$api.managerList(this.pageData).then((res) => {
        if (res.status && res.code === "0000") {
          this.ownerList.push(...res.body.records);
          if (this.pageData.current >= res.body.pages) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
        this.loading = false;
      });
    },
    // 清空数据
    clearData() {
      this.pageData.current = 1;
      this.finished = true;
      this.ownerList = [];
    },
    // 重载页面
    initList() {
      this.clearData();
      this.getList();
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.owner-list {
  margin-top: 24px;
}
</style>
